/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceGroupRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceGroupRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return ResourceGroupRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ResourceGroupRegexQueryOperator>): ResourceGroupRegexQueryOperator {
        let obj = Object.assign(new ResourceGroupRegexQueryOperator(), model);
        ResourceGroupRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceGroupRegexQueryOperator>): ResourceGroupRegexQueryOperator {
        if (!model) return null;
        return ResourceGroupRegexQueryOperator.newInstance(<ResourceGroupRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceGroupRegexQueryOperator) {
        if (!obj) return;

        models.ResourceGroupRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceGroupRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceGroupRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.resource_group) {
            models.Regex.fixupPrototype(this.resource_group);
        }
    }

    /**
     * Include response that has the given resource_group
     */
    resource_group: models.Regex;

}
